module.exports = __webpack_public_path__ + "img/logo.d8e0d5af.png";